import styled from "styled-components";

export const TableContainer = styled.div`
  padding: 45px 23px;
  padding-top: 0px;
`;
